(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-information"]) return;
  try {
    
const observer = new IntersectionObserver((entries, obs) => {
  entries.forEach(entry => {
    if (!entry.isIntersecting) return;

    const dm = entry.target;
    const btn = dm.querySelector('[ref="deferredMediaPlayButton"]');
    if (btn) btn.click(); // mounts video from <template>

    const setup = () => {
      const v = dm.querySelector('video');
      if (v) {
        v.loop = true;
        v.muted = true;
        v.play().catch(() => {});
      }
    };

    new MutationObserver((_, mo) => {
      setup();
      mo.disconnect();
    }).observe(dm, { childList: true, subtree: true });

    obs.unobserve(dm); // only trigger once per video, ever
  });
}, { threshold: 0.25 });

document.querySelectorAll('deferred-media').forEach(dm => observer.observe(dm));

  } catch(e) { console.error(e); }
})();
})();
